export const PADDING_BETWEEN = '12px';
export const PADDING_BOTTOM = '7.7px';
export const VIEW_MORE_BUTTON_TEXT = 'view more';
